import { useContext } from 'react';
import { useParams } from 'react-router';
import { UserContext } from 'app/state/contexts';
import { useGetDocument } from 'app/api/documents/document-queries';
import { useStyle } from 'app/api/style-queries';
import { useDraft, useSaveDraft } from 'app/api/draft-queries';

interface UseDesignDraftOptions {
  styleType: string;
  parsed?: boolean;
}

export function useDesignDraft({ styleType, parsed = true }: UseDesignDraftOptions) {
  const { documentId } = useParams<{ documentId: string }>();
  const { selectedOrganization } = useContext(UserContext);

  const pDocument = useGetDocument(documentId, selectedOrganization);
  const designEntry = pDocument.data?.content.design.find((d: any) => d.type === styleType);
  const styleId = designEntry?.styleId;

  const style = useStyle({
    organization: selectedOrganization,
    documentRevisionId: pDocument.data?.revisionId,
    styleId,
    parsed,
  });

  const draft = useDraft({ documentSuperId: documentId });
  const draftEntry = draft.data?.content?.find((s: any) => s.type === styleType);
  const { mutate: saveDraft } = useSaveDraft();

  return {
    documentId,
    pDocument,
    designEntry,
    style,
    draft,
    draftEntry,
    saveDraft,
  };
}
